module.exports = __webpack_public_path__ + "media/images/icons/flags/NF-81c2d0d85a3e036ee2cddf9af1150bfd.svg";